module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI5LjMyMiIgaGVpZ2h0PSIxNi4zMDUiIHZpZXdCb3g9IjAgMCA5LjMyMiAxNi4zMDUiPgogIDxwYXRoIGlkPSJJY29uX2lvbmljLWlvcy1hcnJvdy1iYWNrIiBkYXRhLW5hbWU9Ikljb24gaW9uaWMtaW9zLWFycm93LWJhY2siIGQ9Ik0yLjgxLDguMTU1LDguOTgsMTQuMzE5YTEuMTY1LDEuMTY1LDAsMSwxLTEuNjUsMS42NDZMLjMzOSw4Ljk4QTEuMTYzLDEuMTYzLDAsMCwxLC4zMDUsNy4zNzNMNy4zMjQuMzRhMS4xNjUsMS4xNjUsMCwwLDEsMS42NSwxLjY0NloiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./static/blog/img/icn_previous.svg
// module id = 2iqw
// module chunks = 0